import React from 'react';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import './TripStatusToggle.css';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

// Define the different statuses and their corresponding label and icon
const statuses = [
    // { value: 'cancelled', label: 'בוטלו', icon: <CancelOutlinedIcon className="filter-menu-icon" /> },
    { value: 'past', label: 'עברו', icon: <HistoryOutlinedIcon className="filter-menu-icon" /> },
    { value: 'planned', label: 'מתוכננים', icon: <EventAvailableOutlinedIcon className="filter-menu-icon" /> },
    { value: 'in-process', label: 'בתהליך', icon: <AccessTimeIcon className="filter-menu-icon" /> }
];

// Component to toggle trip status filters
const TripStatusToggle = ({ statusFilter, onStatusChange }) => {
    // Toggle the selected status filter
    const handleClick = (status) => {
        const newStatus = statusFilter === status ? null : status; // If already selected, deselect
        onStatusChange(null, newStatus); // Trigger parent callback with new status
    };

    return (
        <div className="trips-status">
            <Stack direction="row" spacing={1} dir="ltr">
                {/* Render a Chip for each status */}
                {statuses.map(({ value, label, icon }) => (
                    <Chip
                        className={`chip chip-${value} ${statusFilter === value ? "clicked" : ""}`} // Add class if selected
                        key={value}
                        label={label}         // Status label (in Hebrew)
                        clickable             // Makes chip clickable
                        onClick={() => handleClick(value)} // Toggle filter on click
                        color={statusFilter === value ? 'primary' : 'default'} // Highlight if selected
                        variant={statusFilter === value ? 'filled' : 'outlined'} // Filled if selected
                        icon={icon}           // Display icon
                    />
                ))}
            </Stack>
        </div>
    );
};

export default TripStatusToggle;
